import { Button, Table, Toggle } from '@itds/elements';
import React, { useEffect, useState } from 'react';

import Api from '@carrier/utils/Api';
import { PropTypes } from 'prop-types';
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';

const AnnuityQuotes = ({ carrier }) => {
  const navigate = useNavigate();

  const [annuityQuote, setAnnuityQuote] = useState(null);
  const [annuityQuotes, setAnnuityQuotes] = useState([]);

  useEffect(() => {
    loadDataVersions();
  }, []);

  const loadDataVersions = () => {
    Api.loadAnnuityQuotes({ carrier_id: carrier.id }).then(({ data }) => {
      setAnnuityQuotes(data);
    });
  };

  const handleCreate = () => {
    Api.createDataVersion({ carrier_id: carrier.id }).then(() => {
      loadDataVersions();
    });
  };

  const toggleBeta = (annuityQuote, e) => {
    e.stopPropagation();

    Api.updateAnnuityBeta(annuityQuote.id, {
      is_beta: !annuityQuote.is_beta
    }).then(() => {
      loadDataVersions();
    });
  };

  // NOTE: Hornet makes sure that only one data_version is live at a time
  const toggleLive = (annuityQuote, e) => {
    e.stopPropagation();

    Api.updateAnnuityLive(annuityQuote.id, {
      is_live: !annuityQuote.is_live
    }).then(() => {
      loadDataVersions();
    });
  };

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 30 }}>
        <Button onClick={handleCreate}>New Version</Button>
      </div>

      <Table
        columns={[
          {
            id: 'id',
            label: 'ID',
            render: annuityQuote => annuityQuote.id
          },
          {
            id: 'name',
            label: 'Name',
            render: annuityQuote => annuityQuote.product_name || 'N/A'
          },
          {
            id: 'created_at',
            label: 'Created',
            render: annuityQuote => format(new Date(annuityQuote.created_at), 'MM/dd/yyyy')
          },
          {
            id: 'updated_at',
            label: 'Updated',
            render: annuityQuote => format(new Date(annuityQuote.updated_at), 'MM/dd/yyyy')
          },
          {
            id: 'beta',
            label: 'Beta',
            render: annuityQuote => (
              <Toggle active={annuityQuote.is_beta} onClick={toggleBeta.bind(null, annuityQuote)} />
            )
          },
          {
            id: 'date_gone_beta',
            label: 'Date Gone Beta',
            render: annuityQuote => {
              return annuityQuote.date_gone_beta
                ? format(new Date(annuityQuote.date_gone_beta), 'MM/dd/yyyy')
                : null;
            }
          },
          {
            id: 'live',
            label: 'Live',
            render: annuityQuote => (
              <Toggle active={annuityQuote.is_live} onClick={toggleLive.bind(null, annuityQuote)} />
            )
          },
          {
            id: 'date_gone_live',
            label: 'Date Gone Live',
            render: quote => {
              return quote.date_gone_live
                ? format(new Date(quote.date_gone_live), 'MM/dd/yyyy')
                : null;
            }
          },
          {
            id: 'source',
            label: 'Source',
            render: annuityQuote => (annuityQuote.api_url ? 'External API' : 'IXN')
          }
        ]}
        data={annuityQuotes}
        onRowClick={r => {
          setAnnuityQuote();
          navigate(`${r.id}`);
        }}
      />
    </>
  );
};

AnnuityQuotes.propTypes = {
  carrier: PropTypes.object
};

export default AnnuityQuotes;
